
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.173 14.38H1.835V5.42h14.338m0-1.792h-7.17l-1.79-1.792H1.835c-.995 0-1.792.797-1.792 1.792V14.38a1.792 1.792 0 001.792 1.792h14.338a1.792 1.792 0 001.792-1.792V5.42a1.792 1.792 0 00-1.792-1.792z"}})])
          )
        }
      }
    